export default __webpack_public_path__ + "static/sr-margaret-hero-fa1975f44c7ac5954b96b890560fdb8b.jpg";